import GraphModal from "./GraphModal";
import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useForm, SubmitHandler } from 'react-hook-form';
import { useCookies } from 'react-cookie';
import { DashbordParam, LogoutInputs, SensorKind, WbgtData } from "../Consts/typs";
import {ApiRequest} from "../Consts/ApiRequest";

const Dashboard = (prop: DashbordParam) => {
    const navigate = useNavigate();
    const [sensorKinds, setSensorKinds] = useState<SensorKind[]>([]);
    const [lastDate, setLastDate] = useState<string>("");
    const [counter, setCounter] = useState(60); // カウンターを60に初期化
    const [wbgtUpdatedFlag, setWbgtUpdateFlag] = useState(true); // WBGT(暑さ指数)データ更新用のフラグ(アクセス時は表示するデータが必要なのでtrue)
    const [wbgtData, setWbgtData] = useState<WbgtData[]>([]);
    const [siteName, setSiteName] = useState<string>("");

    const { register, handleSubmit, formState: { errors } } = useForm<LogoutInputs>();
    const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', "siteId", "siteRecno"]);
    const params: DashbordParam = useParams<DashbordParam>();
    const userId = params.userId;
    const siteRecno = params.siteRecno;
    let openGraph = false;

    function errorCallback(error:any){
        if (error.response && error.response.status === 401) {
            console.error("Error token error:", error);
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
        console.error("Error fetching dataSite:", error);
    }

    // useEffect(() => {
    //     const timer = setInterval(() => {
    //         // カウンターが0でなければデクリメント
    //         if (counter > 0) {
    //             if(!openGraph){
    //                 setCounter(counter-1);
    //             }else{
    //                 setCounter(counter);
    //             }
    //         }
    //     }, 1000);

    //     // コンポーネントがアンマウントされたときにクリーンアップ
    //     return () => {
    //         clearInterval(timer);
    //     };
    // }, [counter]);

    // useEffect(() => {
    //     // カウンターが0になったら特定の関数を実行
    //     if (counter === 0) {
    //         getDashBoard();
    //         setCounter(60);
    //     }
    // }, [counter]);

    useEffect(() => {
        const timer = setInterval(() => {
            setCounter(prevCounter => {
                if (prevCounter > 0) {
                    return !openGraph ? prevCounter - 1 : prevCounter;
                }
                return prevCounter;
            });
        }, 1000);

        return () => {
            clearInterval(timer);
        };
    }, [openGraph]);

    useEffect(() => {
        if (counter === 0) {
            getDashBoard();
            setCounter(60);
        }
    }, [counter]);

    useEffect(() => {
        const wbgtUpdateFlag = () => {
            setWbgtUpdateFlag(prevFlag => !prevFlag);
        };

        const wbgtNextUpdate = () => {
            const now = new Date();
            const nextUpdate = new Date(now);

            // 次の10分刻みの時間を計算
            const minutes = Math.ceil(now.getMinutes() / 10) * 10;
            nextUpdate.setMinutes(minutes, 0, 0);

            return nextUpdate.getTime() - now.getTime();
        };

        const initialDelay = wbgtNextUpdate();

        const timeoutId = setTimeout(() => {
            wbgtUpdateFlag();
            const intervalId = setInterval(wbgtUpdateFlag, 10 * 60 * 1000); // 10分ごとに更新

            return () => clearInterval(intervalId); // クリーンアップ
        }, initialDelay);

        return () => clearTimeout(timeoutId); // コンポーネントのクリーンアップ
    }, []);

    useEffect(() => {
        const token = cookies.access_token || "";
        let params = {
            siteId: userId ?? "",
            siteRecno: siteRecno ?? ""
        };
        ApiRequest.getSiteSetting(params,  token, (response:any) => {
            setSiteName(response.data.siteName);
        }, (error:any) => {
            errorCallback(error);
        });

        getDashBoard();
    }, []);

    function getDashBoard(){
        const token = cookies.access_token || "";
        let params = {
            "siteId": userId ?? "",
        };
        ApiRequest.getDashBoard(params, token, (response:any) => {
            setLastDate(response.data.lastDate);
            setSensorKinds(response.data.sensorKinds);
            if (wbgtUpdatedFlag) {
                const wbgtData = response.data.sensorKinds
                .filter((sensorKind: { sensorKind: number; sensors: any[] }) => sensorKind.sensorKind === 2) // 型を指定
                .flatMap((sensorKind: { sensors: any[] }) =>
                    sensorKind.sensors.map((sensor: { data: { wbgtDetail: any; wbgtSituation: any } }) => ({
                        wbgtDetail: sensor.data.wbgtDetail,
                        wbgtSituation: sensor.data.wbgtSituation,
                    }))
                );
                setWbgtData(wbgtData);
                setWbgtUpdateFlag(false);
            }
        }, (error: any) => {
            errorCallback(error);
        })
    }

    const onSubmit: SubmitHandler<LogoutInputs> = async (data) => {
        const token = cookies.access_token || "";
        ApiRequest.postLogout(token, () => {
            removeCookie('access_token', { path: '/' });
            removeCookie('authority', { path: '/' });
            console.log("deleted token");
            navigate("/login");
        }, (error: any) => {
            errorCallback(error);
        });
    };

    useEffect(() => {
        if (!cookies.access_token) navigate("/login");
    }, [])

    const getTopPage = () => {
        if(cookies.authority == 2) return "/site_admin";
        if(cookies.authority > 2) return `/dashboard/${cookies.siteId}/${cookies.siteRecno}`;
        return "/topmenu";
    }

    const graphModalProps = (sensor: any, sensorKind: SensorKind) => ({
        openCallback: () => {
            openGraph = true;
        },
        closeCallback: () => {
            openGraph = false;
        },
        siteId: params.userId,
        siteRecno: params.siteRecno,
        gatewayRecno: sensor.gatewayRecno,
        gatewayCtrlNo: sensor.gatewayCtrlNo,
        sensorRecno: sensor.sensorRecno,
        sensorName: sensor.sensorName,
        sensorId: sensor.sensorId,
        sensorKind: sensorKind.sensorKind,
    });

    return (
        <div className="wrapper">
            <header className="header" id="header">
                <div className="header-main">
                    {cookies.authority == 1 ?
                        <div className="header-topmenu">
                            <Link to="/topmenu">
                                <img src="https://www.sooki-cloud-portalsystem.jp/static/media/icon-topmenu-w.009b2b286bdaa260f21347de5795c2aa.svg" alt="SOOKI" />
                            </Link>
                        </div>:<></>
                    }
                    <div className="header-logo">
                        <Link to={getTopPage()}>
                            <img src="https://www.sooki-cloud-portalsystem.jp/static/media/sooki-logo.7b93a1d920c631c633cc.png" alt="トップメニュー" />
                        </Link>
                    </div>
                    <div className="header-name">ソーキクラウドポータルシステム</div>
                </div>
                <div className="header-sub">
                    <div className="header-genbaname">
                        <span className="header-genbaname-label">現場</span>
                        {siteName}
                    </div>:<></>
                    <Link to={`/menu/${userId}/${siteRecno}`}>
                        {cookies.authority === 4 ? <></> : <button className="btn btn-s btn-blue">メニュー</button>}
                    </Link>
                    <div>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <button type="submit" className="btn btn-s btn-gray-line">
                                ログアウト
                            </button>
                        </form>
                    </div>
                </div>
            </header>
            <main className="main">
                <section className="page-head" id="page-head">
                    <div className="page-head-block">
                        <div className="page-name">
                            {cookies.authority < 3 ?
                                <a onClick={() => navigate(-1)}>
                                <img src="https://www.sooki-cloud-portalsystem.jp/static/media/icon-back-b.a302f48a196965a4ff8d4568031a609b.svg" alt="戻る" /></a>
                                :<></>
                            }
                            <div className="page-name-label">ダッシュボード</div>
                        </div>
                    </div>
                    <div className="page-head-block">
                        <div className="page-info-box">
                            <div className="page-info-item">
                                <span className="page-info-label">現場名</span>{siteName}
                            </div>
                        </div>
                        <div className="page-info-box">
                            <span className="page-info-option">最終更新：{lastDate}</span>
                        </div>
                    </div>
                </section>

                <section className="page-body scroll-block">

                    {sensorKinds[0]?.sensors?.length === 0 && sensorKinds[1]?.sensors?.length === 0 && sensorKinds[2]?.sensors?.length === 0 ?
                        <div style={{ padding: "10px 10px", color: 'red', fontSize: "2rem" }}>
                            センサー情報がありません
                        </div> : <></>}
                    <div className="dashboard-outline">
                        {sensorKinds.filter((e) => e.sensors.length>0).map((sensorKind, sensorKindIndex) => (
                            <div className={"dashboard-inline dashboard-inline-" + sensorKind.sensorKind} key={sensorKind.sensorKind}>
                                <div className="dashboard">
                                    <div className="dashboard-boxes">
                                        {/* 気象 */}
                                        {sensorKind.sensorKind === 2 ? (
                                            <span className="dashboard-box-wrapper dashboard-box-double">
                                                <div className="dashboard-box">
                                                    <div className="dashboard-box-name">
                                                        気象
                                                    </div>
                                                    {sensorKind.sensors.map((sensor, sensorIndex) => (
                                                        <div key={sensor.sensorRecno}>
                                                            <div className="dashboard-box-item">
                                                                <div className="dashboard-box-item-name">
                                                                    {sensor.sensorName}
                                                                </div>
                                                                <div className="dashboard-box-item-label">
                                                                    {sensor.gatewayCtrlNo}
                                                                </div>
                                                                <div className="dashboard-box-item-datum">
                                                                    <GraphModal {...graphModalProps(sensor, sensorKind)}
                                                                        childKind={sensor.data?.tmpDetail?.childKind}
                                                                        childUnit={sensor.data?.tmpDetail?.childUnit}
                                                                        childName={sensor.data?.tmpDetail?.childName}
                                                                        sensorValue={sensor.data?.tmpDetail?.value}
                                                                        iconName={"dashboard-box-item-data-icon icon-temperature-b"}
                                                                    />
                                                                    <GraphModal {...graphModalProps(sensor, sensorKind)}
                                                                        childKind={sensor.data?.humdDetail?.childKind}
                                                                        childUnit={sensor.data?.humdDetail?.childUnit}
                                                                        childName={sensor.data?.humdDetail?.childName}
                                                                        sensorValue={sensor.data?.humdDetail?.value}
                                                                        iconName={"dashboard-box-item-data-icon icon-humidity-b"}
                                                                    />
                                                                    <GraphModal {...graphModalProps(sensor, sensorKind)}
                                                                        childKind={sensor.data?.windDetail?.childKind}
                                                                        childUnit={sensor.data?.windDetail?.childUnit}
                                                                        childName={sensor.data?.windDetail?.childName}
                                                                        sensorValue={sensor.data?.windDetail?.value}
                                                                        iconName={"dashboard-box-item-data-icon icon-winddirection-b"}
                                                                    />
                                                                    <GraphModal {...graphModalProps(sensor, sensorKind)}
                                                                        childKind={sensor.data?.speedDetail?.childKind}
                                                                        childUnit={sensor.data?.speedDetail?.childUnit}
                                                                        childName={sensor.data?.speedDetail?.childName}
                                                                        sensorValue={sensor.data?.speedDetail?.value}
                                                                        iconName={"dashboard-box-item-data-icon icon-windspeed-b"}
                                                                    />
                                                                    <GraphModal {...graphModalProps(sensor, sensorKind)}
                                                                        childKind={sensor.data?.rainDetail?.childKind}
                                                                        childUnit={sensor.data?.rainDetail?.childUnit}
                                                                        childName={sensor.data?.rainDetail?.childName}
                                                                        sensorValue={sensor.data?.rainDetail?.value}
                                                                        iconName={"dashboard-box-item-data-icon icon-rainfall-b"}
                                                                    />
                                                                    {wbgtData.length > sensorIndex && (
                                                                        <GraphModal {...graphModalProps(sensor, sensorKind)}
                                                                            childKind={wbgtData[sensorIndex].wbgtDetail?.childKind}
                                                                            childUnit={wbgtData[sensorIndex].wbgtDetail?.childUnit}
                                                                            childName={wbgtData[sensorIndex].wbgtDetail?.childName}
                                                                            sensorValue={wbgtData[sensorIndex].wbgtDetail?.value}
                                                                            sensorLabel={wbgtData[sensorIndex].wbgtSituation?.value}
                                                                            iconName={"dashboard-box-item-data-icon icon-wbgt-b"}
                                                                        />
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="dashboard-box-opt">
                                                                <div className="dashboard-box-opt-item">
                                                                    <div className="opt-item-label">{sensor.data["tmpMax"]?.childName}</div>
                                                                    <div className="opt-item-data">
                                                                        {sensor.data?.tmpMax?.value}
                                                                        <span>
                                                                        {sensor.data?.tmpMax?.childUnit}
                                                                        </span></div>
                                                                </div>
                                                                <div className="dashboard-box-opt-item">
                                                                    <div className="opt-item-label">{sensor.data["rainBegin"]?.childName}</div>
                                                                    <div className="opt-item-data">
                                                                        {sensor.data?.rainBegin?.value}
                                                                        <span>
                                                                        {sensor.data?.rainBegin?.childUnit}
                                                                        </span></div>
                                                                </div>
                                                                <div className="dashboard-box-opt-item">
                                                                    <div className="opt-item-label">{sensor.data["tmpMin"]?.childName}</div>
                                                                    <div className="opt-item-data">
                                                                        {sensor.data?.tmpMin?.value}
                                                                        <span>
                                                                        {sensor.data?.tmpMin?.childUnit}
                                                                        </span></div>
                                                                </div>
                                                                <div className="dashboard-box-opt-item">
                                                                    <div className="opt-item-label">{sensor.data["rain1hour"]?.childName}</div>
                                                                    <div className="opt-item-data">
                                                                        {sensor.data?.rain1hour?.value}
                                                                        <span>
                                                                        {sensor.data?.rain1hour?.childUnit}
                                                                        </span></div>

                                                                </div>
                                                                <div className="dashboard-box-opt-item">
                                                                    <div className="opt-item-label">{sensor.data["speedMax"]?.childName}</div>
                                                                    <div className="opt-item-data">
                                                                        {sensor.data?.speedMax?.value}
                                                                        <span>
                                                                        {sensor.data?.speedMax?.childUnit}
                                                                        </span></div>
                                                                </div>
                                                                <div className="dashboard-box-opt-item">
                                                                    <div className="opt-item-label">{sensor.data["rain24hour"]?.childName}</div>
                                                                    <div className="opt-item-data">
                                                                        {sensor.data?.rain24hour?.value}
                                                                        <span>
                                                                        {sensor.data?.rain24hour?.childUnit}
                                                                        </span></div>
                                                                </div>
                                                                <div className="dashboard-box-opt-item">
                                                                    <div className="opt-item-label">{sensor.data["10minSpeed"]?.childName}</div>
                                                                    <div className="opt-item-data">
                                                                        {sensor.data["10minSpeed"]?.value}
                                                                        <span>
                                                                        {sensor.data["10minSpeed"]?.childUnit}
                                                                        </span></div>
                                                                </div>
                                                                <div className="dashboard-box-opt-item">
                                                                    <div className="opt-item-label">{sensor.data?.wbgtDetail?.childName}</div>
                                                                    <div className="opt-item-data" style={{ textAlign: "right" }}>
                                                                        {wbgtData.length > sensorIndex ? wbgtData[sensorIndex].wbgtDetail?.value : ''}
                                                                        <span>
                                                                            {sensor.data?.wbgtDetail?.childUnit}
                                                                        </span>
                                                                        <br />
                                                                            {wbgtData.length > sensorIndex ? wbgtData[sensorIndex].wbgtSituation?.value : ''}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </span>
                                        ) : (<></>)}

                                        {/* 騒音振動 */}
                                        {sensorKind.sensorKind === 3 ? (
                                            <div className="dashboard-box-wrapper dashboard-box-single">
                                                <div className="dashboard-box">
                                                    <div className="dashboard-box-name">
                                                        騒音振動
                                                    </div>
                                                    {sensorKind.sensors.map((sensor, sensorIndex) => (
                                                        <div className="dashboard-box-item" key={sensor.sensorRecno}>
                                                            <div className="dashboard-box-item-name">
                                                                {sensorKind.sensorKind === 3 ? sensor.sensorName : '-'}
                                                            </div>
                                                            <div className="dashboard-box-item-label">
                                                                {sensorKind.sensorKind === 3 ? sensor.gatewayCtrlNo : '-'}
                                                            </div>
                                                            <div className="dashboard-box-item-datum">
                                                                <GraphModal {...graphModalProps(sensor, sensorKind)}
                                                                    childName={sensor.data?.noiseDetail?.childName}
                                                                    childKind={sensor.data?.noiseDetail?.childKind}
                                                                    childUnit={sensor.data?.noiseDetail?.childUnit}
                                                                    sensorValue={sensor.data?.noiseDetail?.value}
                                                                    iconName={"dashboard-box-item-data-icon icon-noise-b"}
                                                                />
                                                                <GraphModal {...graphModalProps(sensor, sensorKind)}
                                                                    childName={sensor.data?.vibDetail?.childName}
                                                                    childKind={sensor.data?.vibDetail?.childKind}
                                                                    childUnit={sensor.data?.vibDetail?.childUnit}
                                                                    sensorValue={sensor.data?.vibDetail?.value}
                                                                    iconName={"dashboard-box-item-data-icon icon-vibration-b"}
                                                                />

                                                            </div>
                                                            <div className="dashboard-box-item-opt">
                                                                <div className="dashboard-box-item-opt-item">
                                                                    <div className="opt-item-label">1日の最大騒音</div>
                                                                    <div className="opt-item-data">
                                                                        {sensor.data?.noiseMax?.value}
                                                                        <span>
                                                                        {sensor.data?.noiseMax?.childUnit}
                                                                        </span></div>
                                                                </div>
                                                                <div className="dashboard-box-item-opt-item">
                                                                    <div className="opt-item-label">1日の最大振動</div>
                                                                    <div className="opt-item-data">
                                                                        {sensor.data?.vibMax?.value}
                                                                        <span>
                                                                        {sensor.data?.vibMax?.childUnit}
                                                                        </span></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ) : (<></>)}

                                        {/* 水位 */}
                                        {sensorKind.sensorKind === 1 ? (
                                            <div className="dashboard-box-wrapper dashboard-box-single">
                                                <div className="dashboard-box">
                                                    <div className="dashboard-box-name">
                                                        水位
                                                    </div>
                                                    {sensorKind.sensors.map((sensor, sensorIndex) => (
                                                        <div className="dashboard-box-item" key={sensor.sensorRecno}>
                                                            <div className="dashboard-box-item-name">
                                                                {sensorKind.sensorKind === 1 ? sensor.sensorName : '-'}
                                                            </div>
                                                            <div className="dashboard-box-item-label">
                                                                {sensorKind.sensorKind === 1 ? sensor.gatewayCtrlNo : '-'}
                                                            </div>
                                                            <div className="dashboard-box-item-datum">
                                                                <GraphModal {...graphModalProps(sensor, sensorKind)}
                                                                    childName={sensor.data?.waterDetail?.childName}
                                                                    childKind={sensor.data?.waterDetail?.childKind}
                                                                    childUnit={sensor.data?.waterDetail?.childUnit}
                                                                    sensorValue={sensor.data?.waterDetail?.value}
                                                                    iconName={"dashboard-box-item-data-icon icon-waterlevel-b"}
                                                                />
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ) : (<></>)}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            </main>
        </div >
    )
};

export default Dashboard;
